import React from 'react';

import { FormFieldMethodsType, FormFieldStateType, GlobalsType } from '../../../shared/types';
import InlineLabelInputTextInput from '../InlineLabelInputTextInput';
import LabelSecurePassword from '../LabelSecurePassword';

type LabelPasswordInputProps = {
  globals: GlobalsType;
  password: FormFieldStateType;
  formFieldMethods: FormFieldMethodsType;
  securePasswordType: 'login' | 'create-account' | 'reset-password' | 'change-password';
  password_notice_string: string;
  passwordInputClassNames: string;
  autocomplete: string;
};

const LabelPasswordInput = ({
  globals,
  password,
  formFieldMethods,
  securePasswordType,
  password_notice_string,
  passwordInputClassNames,
  autocomplete,
}: LabelPasswordInputProps) => {
  const { error } = password;
  const { sso_app, sso_port, localize, url_params, host } = globals;
  const password_notice = password_notice_string != null ? localize(password_notice_string) : '';
  const errorMessage = password_notice || (error != null && localize(error)) || '';

  return url_params.sso_form != null && url_params.sso_form !== '' ? (
    <LabelSecurePassword
      id='password'
      type={securePasswordType}
      host={host}
      label={localize('PASSWORD')}
      focus={password.focus}
      active={password.active}
      isShow={password.isShow}
      onBlur={formFieldMethods.onBlur('password')}
      message={errorMessage}
      onFocus={formFieldMethods.onFocus('password')}
      sso_app={sso_app}
      isError={Boolean(errorMessage)}
      sso_port={sso_port}
      required
      localize={localize}
      isReady={password.isReady}
      onActive={formFieldMethods.onActive('password')}
      onChange={formFieldMethods.onChange('password')}
      onAutofill={formFieldMethods.onAutofill}
      onKeyPress={formFieldMethods.onKeyPress('password')}
      onShowHide={formFieldMethods.setProperty('password')('isShow')}
      onReadyChange={formFieldMethods.onReadyChange('password')}
    />
  ) : (
    <InlineLabelInputTextInput
      id='password'
      focus={password.focus}
      value={password.value}
      isShowHidePassword
      onKeyPress={formFieldMethods.onKeyPress('password')}
      message={errorMessage}
      onChange={formFieldMethods.onChange('password')}
      isError={Boolean(errorMessage)}
      label={localize('PASSWORD')}
      onBlur={formFieldMethods.onBlur('password')}
      onFocus={formFieldMethods.onFocus('password')}
      className={passwordInputClassNames}
      required
      autoComplete={autocomplete}
    />
  );
};

export default LabelPasswordInput;
